import React, { useState } from "react";
import {
  Grid,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TablePagination,
  Button,
  Paper,
} from "@mui/material";
import Loader from "../../../component/loading-screen/Loader";
import NoDataView from "../../../component/NoDataView";

const PaginateTableBiggBrains = ({
  columns = [],
  list = [],
  totalRows = 0,
  handlePerRowsChange,
  handlePageChange,
  progressPending = false,
  per_page = 10,
  onRowClicked,
  selectableRows = false,
  onSelectedRowsChange,
}) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(per_page);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    if (handlePageChange) handlePageChange(newPage + 1); // backend page is 1-based
  };

  const handleChangeRowsPerPage = (event) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    setRowsPerPage(newRowsPerPage);
    setPage(0);
    if (handlePerRowsChange) handlePerRowsChange(newRowsPerPage);
  };

  const getStatusButtonColor = (status) => {
    switch (status) {
      case "Active":
        return { backgroundColor: "green", color: "white" };
      case "Inactive":
        return { backgroundColor: "red", color: "white" };
      default:
        return { backgroundColor: "gray", color: "white" };
    }
  };

  return (
    <Grid
      sx={{
        objectFit: "cover",
        position: "relative",
      }}
    >
      <Loader loading={progressPending} circleBlue />
      <TableContainer
        component={Paper}
        sx={{
          overflowX: "auto",
          width: "100%",
          maxWidth: "93vw",
        }}
      >
        <Table
          sx={{
            minWidth:
              columns.length <= 5
                ? "700px"
                : columns.length <= 10
                ? "1350px"
                : "1750px",
            tableLayout: "auto",
          }}
        >
          <TableHead>
            <TableRow sx={{ bgcolor: "#e3f2fd" }}>
              {columns.length > 0 ? (
                columns.map((column) => (
                  <TableCell
                    key={column.name || column.id}
                    sx={{
                      color: "black",
                      textAlign: column.textAlign || "center",
                      fontSize: "13px",
                      fontWeight: "bold",
                    }}
                  >
                    {column.name}
                  </TableCell>
                ))
              ) : (
                <TableCell
                  colSpan={columns.length || 1}
                  sx={{ textAlign: "center" }}
                >
                  No Columns Available
                </TableCell>
              )}
            </TableRow>
          </TableHead>

          <TableBody>
            {list.length > 0 ? (
              list.map((row, index) => (
                <TableRow
                  key={index}
                  onClick={() => onRowClicked && onRowClicked(row)}
                >
                  {columns.map((column) => (
                    <TableCell
                      key={column.name || column.id}
                      sx={{
                        textAlign: column.textAlign || "center",
                        width: column.width || "auto",
                        color: column.color || "inherit",
                        fontWeight: column.fontWeight || "normal",
                      }}
                    >
                      {column.selector ? (
                        column.selector(row)
                      ) : column.statusButton ? (
                        <Button
                          variant="contained"
                          sx={{
                            backgroundColor: getStatusButtonColor(
                              row[column.id]
                            ).backgroundColor,
                            color: getStatusButtonColor(row[column.id]).color,
                            padding: "5px 10px",
                            textTransform: "none",
                          }}
                        >
                          {row[column.id]}
                        </Button>
                      ) : (
                        row[column.id]
                      )}
                    </TableCell>
                  ))}
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell
                  colSpan={columns.length || 1}
                  sx={{ textAlign: "center" }}
                >
                  <NoDataView />
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      <TablePagination
        rowsPerPageOptions={[5, 10, 15, 20, 25, 30, 35, 40, 45, 50]}
        component="div"
        count={totalRows || list.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Grid>
  );
};

export default PaginateTableBiggBrains;
